module.exports = __webpack_public_path__ + "assets/img/component_pc.ae8ac875.jpg";